import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Breadcrumbs,
  Link,
  Typography,
  Button,
  makeStyles,
} from "@material-ui/core";
import { Add as AddIcon, NavigateNext as NavIcon } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  breadcrumb: {
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  current: {
    fontWeight: 600,
  },
}));

const BreadcrumbNav = ({ path, onNavigate, onCreateFolder }) => {
  const classes = useStyles();
  const { t } = useTranslation("translation", {
    keyPrefix: "rgm.cockpit.scenario_manager.breadcrumb",
  });

  return (
    <Box className={classes.container}>
      <Breadcrumbs separator={<NavIcon fontSize="small" />}>
        <Link
          className={classes.breadcrumb}
          color="inherit"
          onClick={() => onNavigate(null)}
        >
          {t("all")}
        </Link>
        {path.map((folder, index) => {
          const isLast = index === path.length - 1;
          return isLast ? (
            <Typography key={folder.folder_id} className={classes.current}>
              {folder.name}
            </Typography>
          ) : (
            <Link
              key={folder.folder_id}
              className={classes.breadcrumb}
              color="inherit"
              onClick={() => onNavigate(folder.folder_id)}
            >
              {folder.name}
            </Link>
          );
        })}
      </Breadcrumbs>

      {onCreateFolder && (
        <Button size="small" startIcon={<AddIcon />} onClick={onCreateFolder}>
          {t("new_folder")}
        </Button>
      )}
    </Box>
  );
};

BreadcrumbNav.propTypes = {
  path: PropTypes.arrayOf(
    PropTypes.shape({
      folder_id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onNavigate: PropTypes.func.isRequired,
  onCreateFolder: PropTypes.func,
};

BreadcrumbNav.defaultProps = {
  onCreateFolder: null,
};

export default BreadcrumbNav;
